import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";

const CreatePost = () => {
    const [content, setContent] = useState("");
    const { currentUser } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!content.trim()) return;

        try {
            await addDoc(collection(db, "posts"), {
                userId: currentUser.uid,
                email: currentUser.email,
                content: content,
                createdAt: serverTimestamp(),
                likes: [],
                comments: [],
                type: "feed",
            });
            setContent("");
        } catch (error) {
            alert("Ошибка при создании поста: " + error.message);
        }
    };

    return (
        <div style={{ maxWidth: "1000px", margin: "0 auto" }} className="background-generalWall">
            <form onSubmit={handleSubmit} className="">
                <h2 className="wall-header">Общая стена</h2>
                <textarea
                    placeholder="ПИШИ ТУТ"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    rows={4}
                    required
                />
                <button
                    type="submit"
                    className="btn btn-alternate mt-4"
                >
                    ОПУБЛИКОВАТЬ
                </button>
            </form>
        </div>
    );
};

export default CreatePost;